<template>
    <MainContainer>
        <template v-slot:sidebar>&nbsp;</template>
        <div class="notentransfer-mitglieder">
            <h2>Notentransfer Sänger*Innen</h2>
            <NotentransferMitgliederSelection v-model="record" @updateTotals="updateTotals" />
            <hr />
            <template v-if="items && items.length > 0">
                <div class="ar-sv-balance">
                    <h3>Notenübersicht Archivar - Stimmvertreter*in</h3>
                    <b-table-simple :small="size === 'sm'">
                        <b-tr>
                            <b-th>Noten:</b-th>
                            <b-th class="text-center">vom Archivar erhalten</b-th>
                            <b-th class="text-center">an den Archivar zurückgegeben</b-th>
                            <b-th class="text-center">mein Gesamtbestand</b-th>
                            <b-th class="text-center">momentan ausgegeben</b-th>
                            <b-th class="text-center">momentan in meinem Bestand</b-th>
                        </b-tr>
                        <b-tr>
                            <b-td></b-td>
                            <b-td class="text-center">{{totals.sv.issued}}</b-td>
                            <b-td class="text-center">{{totals.sv.returned}}</b-td>
                            <b-td class="text-center">{{totals.sv.all}}</b-td>
                            <b-td class="text-center">{{currentlyIssued}}</b-td>
                            <b-td class="text-center font-weight-bold">{{currentlyAvailableInStock}}</b-td>
                        </b-tr>
                    </b-table-simple>
                </div>
                <hr />
                <div class="notentransfer">
                    <h3>
                        Notenausgabe/-rücknahme Mitglieder
                        <b-button
                            v-if="checkRight('write')"
                            :size="size"
                            variant="secondary"
                            :disabled="printing.busy"
                            @click="printSubscriptionList()"
                        >
                            Unterschriftenliste drucken
                            <template v-if="printing.busy">
                                <Spinner small />
                            </template>
                            <template v-else>
                                <font-awesome-icon icon="arrow-right" />
                            </template>
                        </b-button>
                        <b-button
                            v-if="checkRight('write')"
                            :size="size"
                            class="ml-2"
                            variant="secondary"
                            :disabled="printing.busy"
                            @click="printReturnList()"
                        >
                            Rückgabeliste drucken
                            <template v-if="printing.busy">
                                <Spinner small />
                            </template>
                            <template v-else>
                                <font-awesome-icon icon="arrow-left" />
                            </template>
                        </b-button>
                        <b-button
                            v-if="checkRight('write')"
                            :size="size"
                            class="ml-2"
                            variant="warning"
                            :disabled="printing.busy"
                            @click="printDuring()"
                        >
                            Mahnungen drucken
                            <template v-if="printing.busy">
                                <Spinner small variant="dark" />
                            </template>
                            <template v-else>
                                <font-awesome-icon icon="exclamation-triangle" />
                            </template>
                        </b-button>
                        <b-button
                            v-if="checkRight('write')"
                            :size="size"
                            class="ml-2"
                            variant="danger"
                            :disabled="printing.busy"
                            @click="printBilling()"
                        >
                            Rechnungen drucken
                            <template v-if="printing.busy">
                                <Spinner small variant="light" />
                            </template>
                            <template v-else>
                                <font-awesome-icon icon="receipt" />
                            </template>
                        </b-button>
                    </h3>
                    <Table
                        :fields="fields"
                        :items="items"
                        :isBusy="busy"
                        striped
                        bordered
                        showFilter
                        :responsive="true"
                        sortBy="name"
                    >
                        <template v-slot:thead-top="{data: data}">
                            <b-tr>
                                <b-td></b-td>
                                <b-td colspan="3">
                                    <b-input-group style="width: 400px">
                                        <b-datepicker
                                            v-model="transfer.date"
                                            :size="size"
                                            :disabled="transfer.busy"
                                            :date-format-options="{ 'year': 'numeric', 'month': 'numeric', 'day': 'numeric'}"
                                            locale="de"
                                            start-weekday="1"
                                        />

                                        <b-input-group-append>
                                            <b-button
                                                :size="size"
                                                :disabled="transfer.busy || !someSelected"
                                                variant="outline-danger"
                                                @click="provideTransactions('issued')"
                                            >
                                                Ausgabe
                                                <font-awesome-icon icon="arrow-right" />
                                            </b-button>
                                            <b-button
                                                :size="size"
                                                :disabled="transfer.busy || !someSelected"
                                                variant="outline-success"
                                                @click="provideTransactions('returned')"
                                            >
                                                Rücknahme
                                                <font-awesome-icon icon="arrow-left" />
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-td>
                                <b-td colspan="5"></b-td>
                                <b-td></b-td>
                                <b-td></b-td>
                            </b-tr>
                        </template>
                        <template v-slot:head(selected)>
                            <b-checkbox
                                v-model="multiSelect"
                                :disabled="transfer.busy"
                                @change="selectAll"
                            />
                        </template>

                        <template v-slot:selected="{row: row}">
                            <a :id="row.item.id" :name="row.item.id" />
                            <template v-if="row.item.selected && transfer.busy">
                                <Spinner small />
                            </template>
                            <template v-else>
                                <b-checkbox v-model="row.item.selected" :disabled="transfer.busy" />
                            </template>
                        </template>

                        <template v-slot:issued_transactions="{row: row}">
                            <ul class="date-list">
                                <li
                                    v-for="trans in row.value"
                                    :key="trans.id"
                                    :class="trans.type === 'issue_canceled' ? 'text-secondary' : 'text-danger'"
                                >
                                    <template v-if="trans.type === 'issue_canceled'">
                                        <strike>{{$moment(trans.transferdatum).format("DD.MM.Y")}}</strike>
                                    </template>
                                    <template
                                        v-else
                                    >{{$moment(trans.transferdatum).format("DD.MM.Y")}}</template>
                                    <b-button
                                        class="delete-transaction"
                                        size="sm"
                                        variant="link"
                                        :title="trans.type === 'issue_canceled' ? 'Diese Transaktion wieder aktivieren' : 'Diese Transaktion stornieren'"
                                        :disabled="isTransactionBusy(row.item.id, trans.id)"
                                        v-b-tooltip.hover
                                        @click="toggleTransaction(row.item.id, trans.id)"
                                    >
                                        <template v-if="isTransactionBusy(row.item.id, trans.id)">
                                            <Spinner small />
                                        </template>
                                        <template v-else>
                                            <template v-if="trans.type === 'issue_canceled'">
                                                <font-awesome-icon icon="redo" />
                                            </template>
                                            <template v-else>
                                                <font-awesome-icon icon="times" />
                                            </template>
                                        </template>
                                    </b-button>
                                </li>
                            </ul>
                        </template>

                        <template v-slot:returned_transactions="{row: row}">
                            <ul class="date-list">
                                <li
                                    v-for="trans in row.value"
                                    :key="trans.id"
                                    :class="trans.type === 'return_canceled' ? 'text-secondary' : 'text-success'"
                                >
                                    <template v-if="trans.type === 'return_canceled'">
                                        <strike>{{$moment(trans.transferdatum).format("DD.MM.Y")}}</strike>
                                    </template>
                                    <template
                                        v-else
                                    >{{$moment(trans.transferdatum).format("DD.MM.Y")}}</template>
                                    <b-button
                                        class="delete-transaction"
                                        size="sm"
                                        variant="link"
                                        :title="trans.type === 'return_canceled' ? 'Diese Transaktion wieder aktivieren' : 'Diese Transaktion stornieren'"
                                        :disabled="isTransactionBusy(row.item.id, trans.id)"
                                        v-b-tooltip.hover
                                        @click="toggleTransaction(row.item.id, trans.id)"
                                    >
                                        <template v-if="isTransactionBusy(row.item.id, trans.id)">
                                            <Spinner small />
                                        </template>
                                        <template v-else>
                                            <template v-if="trans.type === 'return_canceled'">
                                                <font-awesome-icon icon="redo" />
                                            </template>
                                            <template v-else>
                                                <font-awesome-icon icon="times" />
                                            </template>
                                        </template>
                                    </b-button>
                                </li>
                            </ul>
                            <template v-if="row.item.total < 0">
                                <b-button
                                    size="sm"
                                    variant="outline-success"
                                    :disabled="transfer.busy"
                                    @click="provideSingleReturn(row.item.id)"
                                >Rückgabe</b-button>
                            </template>
                        </template>

                        <template v-slot:issued="{row: row}">
                            <template v-if="row.value > 0">-{{row.value}}</template>
                            <template v-else>&nbsp;</template>
                        </template>

                        <template v-slot:returned="{row: row}">
                            <template v-if="row.value > 0">{{row.value}}</template>
                            <template v-else>&nbsp;</template>
                        </template>

                        <template v-slot:actions="{row: row}">
                            <template v-if="row.total < 0">
                                <template v-if="isPrintingBusy(row.id)">
                                    <Spinner small />
                                </template>
                                <template v-else>
                                    <b-dropdown
                                        v-if="checkRight('write')"
                                        :size="size"
                                        text="Drucken"
                                        dropleft
                                    >
                                        <b-dropdown-item
                                            v-if="checkRight('write')"
                                            @click="printDuring(row.id)"
                                        >
                                            <font-awesome-icon
                                                icon="exclamation-triangle"
                                                class="text-warning mr-1"
                                            />Mahnung drucken
                                        </b-dropdown-item>
                                        <b-dropdown-item
                                            v-if="checkRight('write')"
                                            @click="printBilling(row.id)"
                                        >
                                            <font-awesome-icon
                                                icon="receipt"
                                                class="text-danger mr-1"
                                            />Rechnung drucken
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </template>
                            </template>
                            <template v-else>
                                <EmptySlot />
                            </template>
                        </template>

                        <template v-slot:custom-foot="{data: data}">
                            <b-tr class="table-secondary">
                                <b-td></b-td>
                                <b-td>
                                    <b-button
                                        size="sm"
                                        @click="createNewMitglied"
                                    >Neues Mitglied eintragen</b-button>
                                </b-td>
                                <b-td colspan="8">
                                    <small>Sollte eine Note an ein Mitglied ausgegeben worden sein, welches noch nicht in als Stammsatz angelegt wurde, kann dieses hier eingetragen werden</small>
                                </b-td>
                                <b-td></b-td>
                            </b-tr>
                            <b-tr
                                v-for="item in createdItems"
                                :key="item.id"
                                class="table-secondary"
                            >
                                <b-td>
                                    <b-checkbox v-model="item.selected" :disabled="transfer.busy" />
                                </b-td>
                                <b-td>-</b-td>
                                <b-td>
                                    <b-input v-model="item.name" size="sm" />
                                </b-td>
                                <b-td>
                                    <b-input v-model="item.vorname" size="sm" />
                                </b-td>
                                <b-td colspan="5">
                                    <template v-if="item.errorMessage">
                                        <span class="small text-danger">
                                            <font-awesome-icon icon="exclamation-triangle" />
                                            {{item.errorMessage}}
                                        </span>
                                    </template>
                                </b-td>
                                <b-td class="text-center">
                                    <b-button
                                        class="delete-transaction"
                                        size="sm"
                                        variant="link"
                                        title="Diesen Eintrag entfernen"
                                        v-b-tooltip.hover
                                        @click="deleteCreatedMitglied(item.id)"
                                    >
                                        <font-awesome-icon icon="times" />
                                    </b-button>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-th class="text-center">
                                    <b-checkbox
                                        v-model="multiSelect"
                                        :disabled="transfer.busy"
                                        @change="selectAll"
                                    />
                                </b-th>
                                <b-td colspan="3">
                                    <b-input-group style="width: 400px">
                                        <b-datepicker
                                            v-model="transfer.date"
                                            :size="size"
                                            :disabled="transfer.busy"
                                            :date-format-options="{ 'year': 'numeric', 'month': 'numeric', 'day': 'numeric'}"
                                            locale="de"
                                            start-weekday="1"
                                        />

                                        <b-input-group-append>
                                            <b-button
                                                :size="size"
                                                :disabled="transfer.busy || !someSelected"
                                                variant="outline-danger"
                                                @click="provideTransactions('issued')"
                                            >
                                                Ausgabe
                                                <font-awesome-icon icon="arrow-right" />
                                            </b-button>
                                            <b-button
                                                :size="size"
                                                :disabled="transfer.busy || !someSelected"
                                                variant="outline-success"
                                                @click="provideTransactions('returned')"
                                            >
                                                Rücknahme
                                                <font-awesome-icon icon="arrow-left" />
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-td>
                                <b-td class="text-right">Summe:</b-td>
                                <b-th class="text-right">
                                    <template
                                        v-if="totals.mitglieder.issued && totals.mitglieder.issued > 0"
                                    >
                                        <span class="text-danger">-{{totals.mitglieder.issued}}</span>
                                    </template>
                                    <template v-else>-</template>
                                </b-th>
                                <b-td class="text-right">Summe:</b-td>

                                <b-th class="text-right">
                                    <template
                                        v-if="totals.mitglieder.returned && totals.mitglieder.returned > 0"
                                    >
                                        <span class="text-success">{{totals.mitglieder.returned}}</span>
                                    </template>
                                    <template v-else>-</template>
                                </b-th>
                                <b-th :class="'mv-nowrap text-right ' + differenceVariant">
                                    <template
                                        v-if="totals.mitglieder.all && totals.mitglieder.all !== 0"
                                    >Differenz: {{totals.mitglieder.all}}</template>
                                </b-th>
                                <b-th></b-th>
                                <b-th></b-th>
                            </b-tr>
                        </template>
                    </Table>
                </div>
            </template>
            <template v-else>
                <CenteredMessage
                    :spinner="busy"
                >Bitte zunächst ein entsprechendes offenes Werk zur Ausgabe/-Rücknahme wählen</CenteredMessage>
            </template>
        </div>
    </MainContainer>
</template>

<script>
import shortid from "shortid";
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import { ApiFactory } from "@/api/ApiFactory.js";
import { BlobUtil } from "@/utils/BlobUtil.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import Table from "@/components/Table/Table";
import NotentransferMitgliederSelection from "@/components/Notentransfer/NotentransferMitgliederSelection/NotentransferMitgliederSelection";
import Spinner from "@/components/Spinner/Spinner";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";
import EmptySlot from "@/components/EmptySlot/EmptySlot";

import "./NotentransferMitglieder.scss";

const NotentransferMitgliederApi = ApiFactory.get("notentransferMitglieder");

export default {
    name: "NotentransferMitglieder",
    mixins: [CommonView, Size],
    components: {
        MainContainer,
        Table,
        NotentransferMitgliederSelection,
        Spinner,
        CenteredMessage,
        EmptySlot
    },
    data() {
        return {
            fields: [
                {
                    key: "selected",
                    label: "",
                    class: "text-center",
                    sortable: false
                },
                {
                    key: "id",
                    label: "ID",
                    sortable: true,
                    thStyle: "width: 20px"
                },
                { key: "name", label: "Name", sortable: true },
                { key: "vorname", label: "Vorname", sortable: true },
                {
                    key: "issued_transactions",
                    label: "Ausgegeben",
                    class: "text-center",
                    thStyle: "width: 125px; min-width: 125px"
                },
                {
                    key: "issued",
                    label: "#",
                    sortable: true,
                    variant: "danger",
                    class: "text-right",
                    thStyle: "width: 10px"
                },
                {
                    key: "returned_transactions",
                    label: "Zurückgenommen",
                    class: "text-center",
                    thStyle: "width: 125px; min-width: 125px"
                },
                {
                    key: "returned",
                    label: "#",
                    sortable: true,
                    variant: "success",
                    class: "text-right",
                    thStyle: "width: 10px"
                },
                {
                    key: "total",
                    label: "Gesamt",
                    sortable: true,
                    class: "text-right font-weight-bold",
                    thStyle: "width: 10px"
                },
                {
                    key: "actions",
                    label: "Aktionen",
                    class: "text-center",
                    thStyle: "width: 20px"
                },
                {
                    key: "spacer",
                    label: "",
                    thStyle: "width: 100%"
                }
            ],
            api: NotentransferMitgliederApi,
            record: {
                sv_id: null,
                werk_id: null,
                noten_id: null,
                notentyp: null
            },
            totals: {
                sv: {
                    issued: 0,
                    returned: 0,
                    all: 0
                },
                mitglieder: {
                    issued: 0,
                    returned: 0,
                    all: 0
                }
            },
            multiSelect: false,
            transfer: {
                date: this.$moment().format("Y-MM-DD"),
                busy: false
            },
            transaction: {
                id: null,
                transaction_id: null
            },
            printing: {
                id: null,
                busy: false
            },
            createdItems: [],
            prefetch: false,
            routeHash: null
        };
    },
    created() {
        this.record.sv_id = this.$route.query.sv_id;
        this.record.werk_id = this.$route.query.werk_id;
        this.record.noten_id = this.$route.query.noten_id;
        this.record.notentyp = this.$route.query.notentyp;
        this.routeHash = this.$route.hash;
        this.fetch();
    },
    computed: {
        someSelected() {
            return (
                this.items.filter(item => item.selected).length +
                    this.createdItems.filter(item => item.selected).length >
                0
            );
        },
        currentlyIssued() {
            return this.totals.mitglieder.all;
        },
        currentlyAvailableInStock() {
            const balanceInStock = parseInt(this.totals.sv.all);
            const currentBalance = parseInt(this.totals.mitglieder.all);
            if (!currentBalance) {
                return "...";
            }
            return balanceInStock + currentBalance;
        },
        differenceVariant() {
            if (
                this.totals.mitglieder.all &&
                this.totals.mitglieder.all !== 0 &&
                this.totals.mitglieder.all < 0
            ) {
                return "table-danger";
            } else {
                return "";
            }
        }
    },
    watch: {
        record: {
            handler(val) {
                this.fetch();
            },
            deep: true
        }
    },
    methods: {
        async fetch() {
            if (
                this.record.sv_id &&
                this.record.werk_id &&
                this.record.noten_id &&
                this.record.notentyp
            ) {
                this.busy = true;
                const response = await this.api.get(
                    this.record.sv_id,
                    this.record.werk_id,
                    this.record.noten_id,
                    this.record.notentyp
                );
                if (response.ok) {
                    var items = response.json.mitglieder;
                    items = items.map(item => this.process(item));
                    this.items = items;
                    this.totals.mitglieder = response.json.totals;
                    this.registerRights(response);
                }
                this.busy = false;
            } else {
                this.items = [];
            }
            this.scrollRowIntoView();
        },
        process(item) {
            if (item.total < 0) {
                item._cellVariants = { total: "danger" };
            }
            item.selected = false;
            item.busy = false;

            return item;
        },
        updateTotals(val) {
            this.totals.sv = val;
        },
        selectAll(val) {
            this.items = this.items.map(item => {
                item.selected = val;
                return item;
            });
            this.createdItems = this.createdItems.map(item => {
                item.selected = val;
                return item;
            });
        },
        createNewMitglied() {
            const newMitglied = {
                id: "new_" + String(shortid.generate()),
                name: "",
                vorname: "",
                status: null,
                selected: true,
                created: true,
                errorMessage: null
            };
            this.createdItems.push(newMitglied);
        },
        async provideSingleReturn(mitglied_id) {
            this.transfer.busy = true;
            var transaction = {
                mitglied_id: mitglied_id,
                type: "returned",
                transferdatum: this.transfer.date,
                anzahl: 1
            };
            transaction = Object.assign(transaction, this.record);
            const response = await NotentransferMitgliederApi.post([
                transaction
            ]);
            if (response.ok) {
                var items = response.json.mitglieder;
                items = items.map(item => this.process(item));
                this.items = items;
                this.totals.mitglieder = response.json.totals;
            }
            this.transfer.busy = false;
        },
        async provideTransactions(type) {
            this.transfer.busy = true;
            const date = this.transfer.date;
            var currentItems = [...this.items];
            const currentCreatedItems = [...this.createdItems];
            currentItems = currentItems.concat(currentCreatedItems);
            var mutatedItems = currentItems.filter(item => item.selected);
            var transactions = mutatedItems.map(item => {
                var transaction = {
                    mitglied_id: item.id,
                    type: type,
                    transferdatum: date,
                    anzahl: 1
                };
                if (item.created) {
                    transaction = Object.assign(transaction, {
                        vorname: item.vorname,
                        name: item.name,
                        created: true
                    });
                }
                transaction = Object.assign(transaction, this.record);
                return transaction;
            });
            const response = await NotentransferMitgliederApi.post(
                transactions
            );
            if (response.ok) {
                var items = response.json.mitglieder;
                items = items.map(item => this.process(item));
                this.items = items;
                this.totals.mitglieder = response.json.totals;

                this.createdItems = currentCreatedItems
                    .map(item => {
                        item.errorMessage =
                            "Das Mitglied konnte nicht angelegt werden. Probieren Sie es erneut oder melden Sie sich bei einem Administrator. Die restlichen Transaktionen wurden korrekt durchgeführt.";
                        return item;
                    })
                    .filter(
                        item =>
                            items.findIndex(
                                it =>
                                    it.name === item.name &&
                                    it.vorname === item.vorname
                            ) !== 1
                    );
            } else {
                if (response.json.validation) {
                    this.makeToast(
                        "Probleme bei Notentransfer",
                        response.json.validation,
                        "danger"
                    );
                }
            }
            this.transfer.busy = false;
        },
        async toggleTransaction(m_id, id) {
            this.transaction.id = m_id;
            this.transaction.transaction_id = id;
            const response = await NotentransferMitgliederApi.deleteTransaction(
                id
            );
            if (response.ok) {
                var items = response.json.mitglieder;
                items = items.map(item => this.process(item));
                this.items = items;
                this.totals.mitglieder = response.json.totals;
            }
            this.transaction.id = null;
            this.transaction.transaction_id = null;
        },
        isTransactionBusy(id, trans_id) {
            return (
                this.transaction.id === id &&
                this.transaction.transaction_id === trans_id
            );
        },
        isPrintingBusy(id) {
            return this.printing.id === id;
        },
        deleteCreatedMitglied(id) {
            this.createdItems = this.createdItems.filter(
                item => item.id !== id
            );
        },
        async printSubscriptionList() {
            this.printing.busy = true;
            const response = await NotentransferMitgliederApi.getSubscriptionList(
                this.record.sv_id,
                this.record.werk_id,
                this.record.noten_id,
                this.record.notentyp
            );
            if (response.ok) {
                BlobUtil.downloadBlob(response.blob, "Unterschriftenliste.pdf");
            }
            this.printing.busy = false;
        },
        async printReturnList() {
            this.printing.busy = true;
            const response = await NotentransferMitgliederApi.getReturnList(
                this.record.sv_id,
                this.record.werk_id,
                this.record.noten_id,
                this.record.notentyp
            );
            if (response.ok) {
                BlobUtil.downloadBlob(response.blob, "Rückgabeliste.pdf");
            }
            this.printing.busy = false;
        },
        async printDuring(id = null) {
            this.printing.busy = true;
            this.printing.id = id;
            const response = await NotentransferMitgliederApi.getDuring(
                this.record.sv_id,
                this.record.werk_id,
                this.record.noten_id,
                this.record.notentyp,
                id
            );
            if (response.ok) {
                BlobUtil.downloadBlob(response.blob, "Mahnung.pdf");
            }
            this.printing.busy = false;
            this.printing.id = null;
        },
        async printBilling(id = null) {
            this.printing.busy = true;
            this.printing.id = id;
            const response = await NotentransferMitgliederApi.getBilling(
                this.record.sv_id,
                this.record.werk_id,
                this.record.noten_id,
                this.record.notentyp,
                id
            );
            if (response.ok) {
                BlobUtil.downloadBlob(response.blob, "Rechnung.pdf");
            }
            this.printing.busy = false;
            this.printing.id = null;
        },
        scrollRowIntoView() {
            this.$nextTick(() => {
                if (this.routeHash) {
                    const id = this.routeHash.replace("#", "");

                    const row = document.querySelector("a[name='" + id + "'");
                    if (row) {
                        row.scrollIntoView();
                    }
                    this.routeHash = null;
                }
            });
        }
    }
};
</script>
